<script>
import commonmark from "commonmark";
import VNodeRenderer from "~/app/VNodeRenderer";
import HandbookLink from "~/components/handbook/HandbookLink";

const reader = new commonmark.Parser();

export default {
    props: {
        markdown: String,
    },

    data: function () {
        return {
            output: "",
        };
    },

    render(h) {
        const renderer = new VNodeRenderer(h, {
            components: {
                link: HandbookLink,
            },
        });

        return renderer.render(reader.parse(this.markdown || ""));
    },
};
</script>
